import {
  FlueBurnMetricAggregateDto as SharedFlueBurnMetricAggregateDto,
  FlueBurnMetricAggregateKeyFactory,
  FlueBurnMetricAggregateNaturalKey,
  FlueBurnMetricAggregateNaturalKeyImpl,
  FlueBurnMetricAggregateTimeUnit,
  FlueId,
} from "firefly-shared-ts-domain";
import { FlueBurnMetricAggregateValuesDto } from "./FlueBurnMetricAggregateValues";
import { DateTimeISO } from "shared-ts-types";
import { DateTime } from "luxon";

export type FlueBurnMetricAggregateDto = Omit<
  SharedFlueBurnMetricAggregateDto,
  "values"
> & {
  values: FlueBurnMetricAggregateValuesDto;
};

export class FlueBurnMetricAggregate {
  readonly key: string;
  readonly flueId: FlueId;
  readonly timeUnit: FlueBurnMetricAggregateTimeUnit;
  readonly time?: DateTime;
  readonly naturalKey: FlueBurnMetricAggregateNaturalKey;
  readonly values: FlueBurnMetricAggregateValuesDto;

  constructor(args: {
    key: string;
    flueId: FlueId;
    timeUnit: FlueBurnMetricAggregateTimeUnit;
    time?: DateTimeISO | DateTime;
    values: FlueBurnMetricAggregateValuesDto;
  }) {
    this.key = args.key;
    this.flueId = args.flueId;
    this.timeUnit = args.timeUnit;
    this.time =
      args.time !== undefined
        ? typeof args.time === "string"
          ? DateTime.fromISO(args.time)
          : args.time
        : undefined;
    this.naturalKey = new FlueBurnMetricAggregateNaturalKeyImpl(
      this.flueId,
      this.timeUnit,
      this.time
    );
    this.values = args.values;
  }

  static empty(
    flueId: FlueId,
    timeUnit: FlueBurnMetricAggregateTimeUnit,
    time?: DateTime
  ): FlueBurnMetricAggregate {
    const key = FlueBurnMetricAggregateKeyFactory.create(
      flueId,
      timeUnit,
      time
    );
    return new FlueBurnMetricAggregate({
      key: key,
      flueId: flueId,
      timeUnit: timeUnit,
      time: time,
      values: {
        burnCount: 0,
        burnCountByEitherStartOrEnd: 0,
        burnStartExcellentCount: 0,
        burnStartGoodCount: 0,
        burnStartBadCount: 0,
        burnStartUnknownCount: 0,
        burnHourCount: 0,
        temperatureAvgMax: 0,
        temperatureMax: 0,
        temperatureAlarmCount: 0,
      },
    });
  }
}
